import CrmServiceModel from "../CrmServiceModel";

export default class IndicatorModel extends CrmServiceModel {
  modelName() {
    return "indicators";
  }
  routes() {
    const routes = super.routes();

    routes["latest"] = `${
      process.env.VUE_APP_CRM_REPOSITORY_URL
      }/api/v1/${this.modelName()}/latest/{key}`;
    
    return routes;
  }
  defaults() {
    return {
      id: null,
      key: null,
      value: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      key: val => this.nullStringMutator(val),
      value: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  latest(key) {
    const method = this.getOption("fetch");
    const route = this.getRoute("latest");
    const url = this.getURL(route, { key });

    return this.request(
      { method, url },
      this.onFetch,
      this.onFetchSuccess,
      this.onFetchFailure
    );
  }
}
